import * as itemsAPI from "./items-api";

export async function getItems(params = {}) {
  try {
    const data = await itemsAPI.index(params);
    return data;
  } catch (err) {
    return err;
  }
}

export async function getFeaturedItems() {
  try {
    const data = await itemsAPI.featured();
    return data;
  } catch (err) {
    return err;
  }
}

export async function getStats() {
  try {
    const data = await itemsAPI.stats();
    return data;
  } catch (err) {
    return err;
  }
}

export async function getHiddenItems(params = {}) {
  try {
    const data = await itemsAPI.hiddenIndex(params);
    return data;
  } catch (err) {
    return err;
  }
}

export async function createItem(newItemData) {
  try {
    const data = await itemsAPI.create(newItemData);
    return data;
  } catch (err) {
    return err;
  }
}

export async function getItem(catalogueId) {
  try {
    const data = await itemsAPI.detail(catalogueId);
    return data;
  } catch (err) {
    return err;
  }
}

export async function deleteItem(id) {
  try {
    const data = await itemsAPI.destroy(id);
    return data;
  } catch (err) {
    return err;
  }
}

export async function updateItem(id, itemData) {
  try {
    const data = await itemsAPI.update(id, itemData);
    return data;
  } catch (err) {
    return err;
  }
}

export async function getS3Url(contentType) {
  try {
    const response = await itemsAPI.getS3Url(contentType);
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
}

export async function sendS3Url(url, file) {
  try {
    const response = await itemsAPI.sendS3Url(url, file);
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
}
